import { useState, useEffect, useRef } from "react";

function ActionMenu({ 
  actions, 
  triggerClass = "notification-dots", 
  iconClass = "dots-icon" 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    /* ADDED: The is-active class logic here */
    <div 
      className={`notification-dots-container ${isOpen ? "is-active" : ""}`} 
      ref={menuRef}
    >
      <button className={triggerClass} onClick={toggleMenu} type="button">
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/dots.svg`}
          alt="Actions"
          className={iconClass}
        />
      </button>

      {isOpen && (
        <div className="notification-menu">
          {actions.map((action, index) => (
            action.show !== false && (
              <button
                key={index}
                className={`notification-menu-item ${action.className || ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick();
                  setIsOpen(false);
                }}
              >
                {action.label}
              </button>
            )
          ))}
        </div>
      )}
    </div>
  );
}

export default ActionMenu;